import APIRequestService from './APIRequestService';

const request = new APIRequestService();

export const requestToValidateUserAuthentication = async () => {
  const url = '/users/me';
  return request.get(url);
};
